import { createContext } from 'react';
import { Channel } from '../services';

export interface ChannelContextProps {
  channel: Channel;
  setChannel: (channel: Channel) => void;
}

export const ChannelContext = createContext<ChannelContextProps>({} as ChannelContextProps);
